import React, { useEffect, useRef, useState } from "react";
import FlatPicker from "flatpickr";
import { addQueryLocalStorage, formatDateTime } from "../../../lib/utils";
import Toast from "../../../lib/toast";
import { useLocation, useHistory } from "react-router-dom";

let flatpickr;

const DateFilter = (props) => {

  const [currentElementId, setCurrentElementId] = useState("");

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const isOneTimeLoad = useRef(false);

  const location = useLocation();
  const history = useHistory();

  const toggleInputFields = (id) => {
    if (currentElementId == id) {
      setCurrentElementId('')
    } else {
      setCurrentElementId(id);
      toggleDatePopup(id)
    }
  };

  const toggleDatePopup = (name) => {
        flatpickr = FlatPicker("#"+name, {
          disableMobile: true,
          onChange: (e) => {
           if(name == "startDate"){
            addQueryLocalStorage(name,e[0])
            setStartDate(e[0])
            setEndDate("");
           }else{
            if(new Date(e[0])>=new Date(startDate)){
              addQueryLocalStorage(name,e[0])
              setEndDate(e[0]);
            }else{
              new Toast({
                duration:3000,
                type:"warning",
                message:"End date can't be less then start date."
              })
            }
           }
          }
        })
        flatpickr.open();
  }


  useEffect(()=>{
    const dateRange = {
      startDate,
      endDate
    }
    if(props.getDateRange) props.getDateRange(dateRange);
  },[startDate,endDate])

  useEffect(()=>{
    if(props.isReset){
      setStartDate("");
      setEndDate("")
      props.handleResetState()
    }
    if(props.dateRange && !props.isReset && !startDate && !endDate && !isOneTimeLoad.current){
      setStartDate(props.dateRange.startDate);
      setEndDate(props.dateRange.endDate);
      isOneTimeLoad.current=true;
    }
  },[props]);



  useEffect(()=>{
    const queryParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(queryParams.entries());

    if(params.startDate){
      setStartDate(new Date(params.startDate))
    }else{
      setStartDate("")
    }

    if(params.endDate){
      setEndDate(new Date(params.endDate))
    }else{
      setEndDate("")
    }
  },[window.location.search])

  return(
    <div className="w-full">
      {
        props.header == "invisible" ? (
          <></>
        ): (
          <p className="fs-16 m-t-8 m-b-6 font-weight-700 color-black">Date Filter</p>
        )
      }
      <div className="d-flex w-full space-between">
        <div id="startDate" onClick={()=>toggleInputFields('startDate')} className={`${currentElementId == "startDate" || startDate ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: (currentElementId == "startDate" || startDate) ? "1px solid var(--darkBlue)" : "", width:"48%", paddingLeft:"8px" }}>
          <div className="flex-item d-flex" style={{marginTop: (currentElementId == "startDate" || startDate) ? "4px" : ""}}>
            <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "startDate" || startDate) ? "10px" : "16px", lineHeight: (currentElementId == "startDate" || startDate) ? "10px" : "14px", color: (currentElementId == "startDate" || startDate) ? "var(--darkBlue)" : "", transition: "180ms" }}>Start Date</p>
          </div>
          <input className={`${(currentElementId == "startDate" || startDate) ? "active-input-field" : "inactive-input-field"} m-t-5 fs-16`} type="text" placeholder="DD/MM/YYYY" value={startDate ? formatDateTime(startDate) : ""} />
        </div>
        <div id="endDate" onClick={()=>toggleInputFields('endDate')} className={`${currentElementId == "endDate" || endDate ? "member-global-input-field m-b-12 flex-item" : "member-global-input-field m-b-12 flex-item d-flex"}`} style={{ border: (currentElementId == "endDate" || endDate) ? "1px solid var(--darkBlue)" : "", width:"48%", paddingLeft:"8px" }}>
          <div className="flex-item d-flex" style={{marginTop: (currentElementId == "endDate" || endDate) ? "4px" : ""}}>
            <p className="placeholder-txt flex-item" style={{ fontSize: (currentElementId == "endDate" || endDate) ? "10px" : "16px", lineHeight: (currentElementId == "endDate" || endDate) ? "10px" : "14px", color: (currentElementId == "endDate" || endDate) ? "var(--darkBlue)" : "", transition: "180ms" }}>End Date</p>
          </div>
          <input className={`${(currentElementId == "endDate" || endDate) ? "active-input-field" : "inactive-input-field"} m-t-5 fs-16`} type="text" placeholder="DD/MM/YYYY" value={endDate ? formatDateTime(endDate) : ""} />
        </div>
      </div>
    </div>
  )
}

export default DateFilter;